export const trackKeywordLinkClick = (dropdown, linkUrl, keywordType) => {
    if ('function' == typeof(((window || {}).analytics || {}).track)) {
      window.analytics.track('related keyword clicked', {
        keyword: dropdown,
        url: linkUrl,
        type: keywordType
      });
    }
}

export const trackActivityLinkClick = (activity, linkUrl, activityType) => {
    if ('function' == typeof(((window || {}).analytics || {}).track)) {
      window.analytics.track('popular activity clicked', {
        activity: activity,
        url: linkUrl,
        type: activityType
      });
    }
}

export const trackEvent = (event,properties) => {
  if('function' == typeof(((window || {}).analytics || {}).track)) {
    window.analytics.track(event, properties);
  }
}

export const trackPopularKeywordsKeywordClick = (keyword, source) => {
  if ('function' == typeof(((window || {}).analytics || {}).track)) {
    window.analytics.track('link_clicked', {
      keyword,
      timestamp: Date.now(),
      source,
      label: 'popular keyword'
    });
  }
}

export const trackPopularKeywordsCityClick = (keyword, city, url, source) => {
  if ('function' == typeof(((window || {}).analytics || {}).track)) {
    window.analytics.track('link_clicked', {
      keyword,
      city,
      url,
      timestamp: Date.now(),
      source,
      label: 'keywords city'
    });
  }
}

export const searchError = (inputValue, location, paramNotFound) => {
  if ('function' == typeof(((window || {}).analytics || {}).track)) {
    const properties = {};
    let origin = location;
    if ('modal' === origin) {
      origin = window.location.href;
    }
    properties.label = inputValue;
    properties.origin = origin;
    properties.nonInteraction = 1;
    window.analytics.track(`search: ${paramNotFound} not found`, properties);
  }
};
